var TextElementTypes;
(function (TextElementTypes) {
    TextElementTypes["Span"] = "span";
    TextElementTypes["H1"] = "h1";
    TextElementTypes["H2"] = "h2";
    TextElementTypes["H3"] = "h3";
    TextElementTypes["H4"] = "h4";
    TextElementTypes["H5"] = "h5";
    TextElementTypes["H6"] = "h6";
    TextElementTypes["Paragraph"] = "p";
    TextElementTypes["Strong"] = "strong";
    TextElementTypes["Label"] = "label";
})(TextElementTypes || (TextElementTypes = {}));
var TypographyHorizontalAlign;
(function (TypographyHorizontalAlign) {
    TypographyHorizontalAlign["Left"] = "left";
    TypographyHorizontalAlign["Center"] = "center";
    TypographyHorizontalAlign["Right"] = "right";
})(TypographyHorizontalAlign || (TypographyHorizontalAlign = {}));

export { TextElementTypes, TypographyHorizontalAlign };
